<template>
  <div v-if="show" class="cm-activity-background">
    <Box :title="name" header-color="#0F74BB" :show-close="true" :small="true" @close="$emit('close')" width="90%" headerColor="#0F74BB" icon="mdi-chart-line-variant">
      <div style="padding: 20px">
        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;"> 
          <div style="width: 290px; margin-left: 5px">
            <material-date-time-range class="cm-text-grey" :noIcon="true" :startValue="dates"  :localTime="true" @change="setDates"></material-date-time-range>
          </div> 
          <v-icon large color="#597EAA" @click="downloadFile">mdi-download</v-icon>
        </div>

        <div class="cm-activity-table">
          <v-data-table
            dense
            :headers="tableHeaders"
            :page="page" 
            :loading="loading"
            :items-per-page="itemsPerPage" 
            hide-default-footer 
            fixed-header
            :items="userActivity"
            item-key="name"
            class="elevation-1"
          >
          <template v-slot:footer>
            <Pagination :items="userActivity.length" @updated="(val) => {page = val.page; itemsPerPage = val.itemsPerPage}" />
          </template>

          </v-data-table>
        </div>
      </div>
    </Box> 
  </div>
</template>

<script>
import Box from "@/components/general/Box.vue"
import Pagination from "@/components/general/TablePagination.vue"
import { GetActivityReport } from "@/services/API"
import moment from "moment"
import { parseCSV } from "@/utils"
import { userActivity } from '@/mixins/user-activity.js' 
import { Logger } from "aws-amplify"
const logger = new Logger("USER ACTIVITY")
const xlsx = require('xlsx')

export default {
  components: {
    Box,
    Pagination
  },

  mixins: [userActivity],

  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    user: {
      type: Object,
      default: () => {}
    },
    org: {
      type: String,
      default: () => null
    }
  },

  data () {
    return {
      userActivity: [],
      dates: [`${moment().subtract(7, 'days').format("YYYY-MM-DDT00:00:00")}Z`, `${moment().format("YYYY-MM-DDT23:59:59")}Z`],
      itemsPerPage: 20,
      page: 1,
      tablePagination: [-1],
      loading: false,
    }
  },

  computed: {
    tableHeaders () {
      /*activity: i.action,
              utcTime: i.timestamp,
              localTime: i.timestamp,
              status: i.context_status,
              additionalInfo: i.context_message
      */
       return [
        { text: 'Activity', value: 'activity' },
        { text: 'Time (UTC)', value: 'utcTime' },
        { text: `Local Time (${this.timezone})`, value: 'localTime' },
        { text: 'Status', value: 'status' },
        { text: 'Additional Infomation', value: 'additionalInfo' },
       ]
    },

    timezone () {
      let offsetInMins = moment().utcOffset()
      let symbol = offsetInMins < 0 ? '-' : '+'
      let offsetInHours = offsetInMins == 0 
        ? 0
        : Math.abs(offsetInMins) / 60
      return `UTC${symbol}${offsetInHours}`
    },

    name () {
      return this.user && this.user.Profile 
        ? this.user.Profile.firstname + ' ' + this.user.Profile.lastname
        : 'User activity'
    }
  },

  watch: {
    user (user) {
      this.fetchUserActivity(user)
    }
  },

  mounted () {
    this.fetchUserActivity()
  },

  methods: {
    fetchUserActivity (user = false) {
      logger.debug("fetching user activity")
      const userToSend = user || this.user

      if(!userToSend || !userToSend.email) {
        logger.debug("no user")
        return
      }

      this.loading = true;

      GetActivityReport(this.org, userToSend.email, this.dates).then(async res => {
        logger.debug("fetch success", res)
        this.userActivity = await this.parseCSV(res)
        this.loading = false
      }).catch(err => {
        logger.debug("error", err)
        this.loading = false
      })
    },

    setDates (val) {
      // check we have a Z on our date for UTC. sometimes the component does not provide it
      this.dates = val.map(i => i.includes("Z") ? `${i}` : `${i}Z`)
      this.fetchUserActivity()
    },  

    parseCSV(data) {
      return new Promise(async (res)  => {
       try {
          const file = await fetch(data)
          const fileData = await file.text()
          logger.debug("parseCSV1", JSON.stringify(fileData))
          const parsedData = parseCSV(fileData)
          logger.debug('parseCSV2', data, JSON.parse(JSON.stringify(parsedData)));
          res(parsedData.map(i => {
            return {
              activity: this.userActivityMap(i.action),
              utcTime: i.timestamp,
              localTime: moment.utc(i.timestamp).local().format("YYYY-MM-DD HH:mm:ss"),
              status: this.userActivityMap(i.context_status),
              additionalInfo: i.context_message
            }
          }))
       } catch (err) { 
        logger.debug("parsing error", err) 
        res([])
       }
      })
    },

    downloadFile () {
      this.loading++
      // create our excel file
      const wb = xlsx.utils.book_new()
 
      let data = JSON.parse(JSON.stringify(this.userActivity))

      const sheet = xlsx.utils.json_to_sheet(data.map(i => {
        return {
          Activity: i.activity,
          'Time (UTC)': i.utcTime,
          Status: i.status,
          'Additional Infomation': i.additionalInfo
        }
      }))

      xlsx.utils.book_append_sheet(wb, sheet, "user activity")
      const dates = this.dates.map(i => moment(i).format("YYYY-MM-DD"))
      //xlsx.utils.book_append_sheet(wb, ws, moment().utc(parseInt(this.items[0].UTCTimestamp)).format('YYYY-MM-DD'))
      const reportName = `User_Activity_Report_${dates.join('_')}`
      xlsx.writeFile(wb, reportName + ".xlsx")
      this.loading--
    },
  }
}
</script>

<style lang="scss">
.cm-activity-background {
  z-index: 9;
  position: fixed;
  width: calc(100% - 260px);
  height: 100%;
  top: 0;
  left: 260px;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.cm-activity-table {
   height: 400px;
   overflow-y: scroll;

   &::-webkit-scrollbar {
    width: 5px;
    height: 10px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #aaa;
    transition: all .2s;

    &:hover {
      background: #999;
    }
  }

  .v-data-table-header th .v-data-table-header__icon {
    display: none;
  }

  .v-data-table-header th {
    padding: 7px 16px !important;
    white-space: nowrap !important;
    background: #597EAA !important;
    color: #fff !important;
  }

  .v-data-table-header th:first-child {
    border-top-left-radius: 15px;
  }

  .v-data-table-header th:last-child {
    border-top-right-radius: 15px;
  }

  tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .05);
  }
}
</style>
